export default __webpack_public_path__ + "media/images/page-header-process.jpg";